import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyB4mGZT-OSYki_N6kCC93hPcPENxxErzM4",
  authDomain: "awn-795d8.firebaseapp.com",
  projectId: "awn-795d8",
  storageBucket: "awn-795d8.firebasestorage.app",
  messagingSenderId: "418608026027",
  appId: "1:418608026027:web:8946eabc7c4a26712642ee",
  measurementId: "G-HCL84D4XM2"
};
const app = initializeApp(firebaseConfig);
export default app;
